<template>
  <el-tooltip :content="customerTip" placement="bottom">
    <span
      v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
      class="orange"
    >LV{{ customerLevel.level }}</span>
    <span
      v-show="(contractStatus===2&&typeof customerLevel.level==='number')||parseInt(customerLevel.level)>-1"
      style="color:#D3A73B"
    >&nbsp;{{ customerLevel.customerName }}</span>
    <span
      v-show="contractStatusLabel"
      class="red"
    >&nbsp;({{ contractStatusLabel }})</span>
    <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
    <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
      <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
    </span>
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </el-tooltip>
</template>

<script>
import stampIcon from '@/assets/stamp.jpg'
import stampPictureView from '@/components/Cargo/Job/stampPictureView'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'
import { Company } from '@/class/model/mdm/Company'
import moment from 'moment'
import { dateCompareYMD } from '@/utils/commonUtil'
import { findBusinessDocument } from '@/api/seaExport/businessDocument'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { CreditInfoUtil } from '@/class/cargo/model/utils/CreditInfoUtil'
import selectData from '@/utils/selectData'

export default {
  name: 'CustomerProperty',
  components: {
    stampPictureView
  },
  props: {
    customerId: { type: Number, default: 0 },
    job: { type: Object, default: null }
  },
  data() {
    return {
      stampIcon,
      customerTip: '',
      contractStatus: 0,
      customerLevel: {},
      contractStatusLabel: '',
      advancePaymentLabel: '',
      stampPictureView: {
        visible: false,
        businessDocuments: []
      }
    }
  },
  watch: {
    customerId: {
      immediate: true,
      handler(newVal) {
        const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', newVal)
        this.customerLevel.level = ''
        this.customerLevel.customerName = ''
        this.advancePaymentLabel = ''
        this.contractStatus = 0
        this.contractStatusLabel = ''
        this.customerTip = ''
        this.stampPictureView.businessDocuments = []
        if (!cmp || !cmp.cmpIdx) {
          return
        }
        const company = new Company(cmp)
        Company.loadAgreementClientContract(company.uuid).then(async contracts => {
          if (contracts && contracts.length > 0) {
            const now = moment()
            const businessIds = []
            for (const item of contracts) {
              // 过滤出当前合作伙伴所有未到期的合同
              if (dateCompareYMD(item.endDate, now) >= 0) {
                businessIds.push(item.uuid)
              }
            }
            if (businessIds.length > 0) {
              findBusinessDocument({ businessIds: businessIds }).then(res => {
                const docs = res.data
                if (docs && docs.length > 0) {
                  const useDocs = []
                  for (const doc of docs) {
                    if (!doc.fileCategory || doc.fileCategory !== 'STAMP') continue
                    if (!doc.fileType || !SystemConstants.IMAGES.includes(doc.fileType.toUpperCase())) continue
                    useDocs.push(doc)
                  }
                  this.stampPictureView.businessDocuments = useDocs
                }
              })
            }
            company.contractStatus = businessIds.length > 0 ? 2 : 1
          } else {
            company.contractStatus = 0 // 未签约
          }
          const contractState = selectData.contractStatuses[company.contractStatus]
          this.contractStatus = company.contractStatus
          this.contractStatusLabel = contractState ? contractState.label : ''
          this.customerTip = await JobUtils.getCustomerCreditTip(company.cmpIdx, CreditInfoUtil.getJobData(this.job))
        })
      }
    }
  }
}
</script>
